import { SyntheticEvent } from 'react';
import { ComponentWithAs } from '@chakra-ui/react';

import { ProviderPlanId } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

import { Offer, OfferLinkProps } from '../../types';
import { PlanTag } from '../PlanTag';

interface OfferCardProps {
  offer: Offer;
  to: OfferLinkProps;
  onClick?: (e: SyntheticEvent) => void;
  isCovered?: boolean;
  isCoveredFromPlan?: ProviderPlanId;
}

const OfferCard: ComponentWithAs<'div', OfferCardProps> = ({
  isCovered,
  isCoveredFromPlan,
  offer,
  ...props
}) => (
  <SunshineCard {...props}>
    <SunshineCard.Slot name="aside">
      <SquircleIcon name={offer.icon} />
    </SunshineCard.Slot>

    <SunshineCard.Content>
      <SunshineCard.Title>{offer.title}</SunshineCard.Title>
      <SunshineCard.Text>{offer.description}</SunshineCard.Text>
      {isCovered === false && isCoveredFromPlan ? (
        <PlanTag plan={isCoveredFromPlan} />
      ) : null}
    </SunshineCard.Content>

    <SunshineCard.Slot name="action">
      <SunshineCard.SunshineIcon name="chevron-right" />
    </SunshineCard.Slot>
  </SunshineCard>
);

export default OfferCard;
